import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const impact = [
    { value: "25", label: "original botanical care rituals" },
    { value: "6", label: "clean formulation standards" },
    { value: "100%", label: "vegan and cruelty-free formulas" },
    {
      value: String(siteConfig.policies.returnWindow),
      label: "days for considered returns",
    },
  ];

  const principles = [
    {
      number: "01",
      title: "Plant intelligence",
      text: "We formulate with potent botanical oils, minerals and plant proteins selected for visible, lasting performance.",
    },
    {
      number: "02",
      title: "Purposeful selection",
      text: "Every ingredient has a clear role in the formula, helping us create effective care without unnecessary complexity.",
    },
    {
      number: "03",
      title: "Conscious craft",
      text: "Concentrated formulas and considered packaging help us create more beauty with less excess at every stage.",
    },
  ];

  return (
    <main className="about-page">
      <section className="about-hero" aria-labelledby="about-title">
        <img
          className="about-hero__image"
          src="/main/about-hero.webp"
          alt="Woman with long natural hair in soft botanical studio light"
        />
        <div className="about-hero__shade" aria-hidden="true" />
        <div className="about-hero__content">
          <p className="about-eyebrow">Our truth</p>
          <h1 id="about-title">Better care begins with thoughtful balance</h1>
          <p>
            {siteConfig.brandName} is a plant-powered beauty house rooted in
            the belief that high performance and deep respect for the earth
            belong together.
          </p>
        </div>
      </section>

      <section className="about-intro" aria-labelledby="about-intro-title">
        <p className="about-eyebrow">A new understanding of natural beauty</p>
        <h2 id="about-intro-title">
          Daily care should feel considered, effective and easy to return to.
        </h2>
        <p>
          We pair time-honored plant knowledge with modern formulation to
          create concentrated care for hair, scalp and skin. Every product is
          an invitation to slow down, notice what works and choose beauty that
          gives something meaningful back.
        </p>
      </section>

      <section className="about-impact" aria-label="Our impact">
        {impact.map((item) => (
          <article className="about-impact__item" key={item.label}>
            <strong>{item.value}</strong>
            <span>{item.label}</span>
          </article>
        ))}
      </section>

      <section className="about-story" aria-labelledby="about-story-title">
        <div className="about-story__media">
          <img
            src="/main/about-story.png"
            alt="Botanical oils and ingredients arranged in a clean formulation studio"
            loading="lazy"
          />
        </div>
        <div className="about-story__content">
          <p className="about-eyebrow">The story</p>
          <h2 id="about-story-title">From one balanced formula to a complete routine</h2>
          <p>
            Our story began with a simple question: could everyday
            hair care feel both sensorial and genuinely practical? We started with
            lightweight camellia oil, oat protein and textures designed for busy,
            everyday routines.
          </p>
          <p>
            That discovery became {siteConfig.brandName}—a collection built
            around purposeful ingredients, clear routines and formulas that layer
            easily across different textures, seasons and daily schedules.
          </p>
          <Link className="about-text-link" to="/shop" onClick={toTop}>
            Discover the collection <span aria-hidden="true">→</span>
          </Link>
        </div>
      </section>

      <section className="about-principles" aria-labelledby="principles-title">
        <div className="about-principles__heading">
          <p className="about-eyebrow">What guides us</p>
          <h2 id="principles-title">Designed with intention</h2>
        </div>
        <div className="about-principles__grid">
          {principles.map((principle) => (
            <article key={principle.number}>
              <span>{principle.number}</span>
              <h3>{principle.title}</h3>
              <p>{principle.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="about-mission" aria-labelledby="mission-title">
        <p className="about-eyebrow">Our mission</p>
        <h2 id="mission-title">
          Leave every strand, every community and every ecosystem stronger.
        </h2>
        <p>{siteConfig.description}</p>
        <Link className="about-button" to="/shop" onClick={toTop}>
          Shop plant-powered care
        </Link>
      </section>
    </main>
  );
}

export default About;
